module.exports = __webpack_public_path__ + "static/media/logoTLA.0c5d6543.svg";